enum MasterTableExamType {
  PartI = 1,
  PartII = 2,
  PartIII = 3
}

enum Role {
  President = 1,
  Chairman = 2,
  Chief = 3
}

export const MasterTableEnum = {
  MasterTableExamType,
  Role
}
